import { Component, Input, AfterViewInit } from '@angular/core';
import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
import { FieldType } from '@ngx-formly/core';
import { StepDefinition } from '../dynamic';
import { ContextService, LayoutInterface } from '../../context.service';
import { LayoutComponent } from '../../layout/layout.component';

@Component({
  selector: 'mutara-stepper',
  templateUrl: './stepper.component.html', providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
  ],
  styleUrl: './stepper-header.component.scss',
  standalone: false
})
export class StepperComponent extends FieldType implements AfterViewInit {

  @Input() index: number = 0;
  @Input() isFixed: boolean = false;
  @Input() stepDefinitions: StepDefinition[] | undefined;
  @Input() selected = 0;
  @Input() layout: LayoutComponent | undefined;
  @Input() parentLayout: LayoutInterface | undefined | null;

  isComplete: boolean = false;
  isVertical: boolean = false;


  constructor(private contextService: ContextService) {
    super();
    this.contextService.subscribeTo("orientation", (isVertical: boolean) => {
      this.isVertical = isVertical;
    });

    this.contextService.subscribeTo("stepIndex", (stepField: any) => {
      if (!!stepField && stepField?.layout?.layoutId == this.parentLayout?.layoutId) {
        this.selected = this.stepDefinitions?.findIndex(step => step.step == stepField.step) ?? 0;
      }
      this.reassignTabRole();
    });
  }

  ngAfterViewInit(): void {
    this.reassignTabRole();
  }

  _lookForVisibleChildren(stepToCheck: StepDefinition): boolean {
    let hasVisible = true;
    if (!!stepToCheck.fieldDefinitions) {
      if ((stepToCheck?.fieldDefinitions.length ?? -1) > 0) {
        hasVisible = false;
        stepToCheck.fieldDefinitions.forEach(fldDefn => {
          hasVisible ||= !fldDefn.hide;
        });
      }
    }
    return hasVisible;
  }
  reassignTabRole() {
    let stepperHeaderContainers = document.getElementsByClassName('mat-horizontal-stepper-header-container');
    if (stepperHeaderContainers.length > 0) {
      stepperHeaderContainers[0].setAttribute('role', 'tablist');
      stepperHeaderContainers[0].setAttribute('aria-label', 'Steps in the application process');
    }
    let steppers = document.querySelectorAll('.stepper-orientation, mat-stepper');
    steppers.forEach(stepper => {
      stepper.removeAttribute('aria-orientation');
    });
  }


  get firstStep(): StepDefinition {
    return this.visibleDefinitions[0];
  }

  get visibleDefinitions(): StepDefinition[] {
    return this.stepDefinitions?.filter(defn => this.isStepVisible(defn)) ?? [];
  }

  // We are changing the step which will clear the highlight if set
  setStep($event : any) {
    if (this.selected != $event.selectedIndex) {
      this.contextService.setStepIndex(this.parentLayout, this.stepDefinitions?.[$event.selectedIndex].step);
      // setTimeout( () => this.contextService.updateValidity(), 0);

      this.selected = $event.selectedIndex;
      window.scroll({
        top: 0,
        left: 0
      });
      document.getElementsByClassName('mat-sidenav-content')[0].scroll({
        top: 0,
        left: 0
      });
    }
    this.reassignTabRole();
  }

  isStepVisible(step : any) : boolean {
    return this._evaluateVisible(step?.isVisible) && this._lookForVisibleChildren(step);
  }

  isRequired(step : any) : boolean  {
    return this._evaluateVisible(step?.isRequired);
  }


  _evaluateVisible(toEvaluate: any, defaultValue: boolean = true): boolean{
    let isTrue: boolean = false;
    // If there is something to valuate, isTrue will get set
    if (!!toEvaluate) {
      isTrue = ['1', 'true', true, 1].includes(toEvaluate?.toLowerCase() ?? toEvaluate);
      if (typeof toEvaluate === 'string' && !isTrue) {
        try {
          isTrue = eval(toEvaluate);
        } catch (error) {
          console.debug('Unable to evaluate: %O\n%O', toEvaluate, error);
          isTrue = defaultValue;
        }
      }
    }
    return isTrue ?? defaultValue;
  }
}